"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Swapper = exports.SwapperHeader = void 0;
const web3_js_1 = require("@solana/web3.js");
const borsh_1 = require("borsh");
class SwapperHeader {
    constructor(obj) {
        this.initialized = obj.initialized;
        this.signer_nonce = obj.signer_nonce;
        this.copeMint = new web3_js_1.PublicKey(obj.copeMint);
        this.govTokenMint = new web3_js_1.PublicKey(obj.govTokenMint);
        this.govTokenPerCope = obj.govTokenPerCope;
        this.maxQuantityPerWallet = obj.maxQuantityPerWallet;
        this.adminAddress = new web3_js_1.PublicKey(obj.adminAddress);
        this.cope_vault = new web3_js_1.PublicKey(obj.cope_vault);
    }
    static async retrieve(connection, swapperStateAccount) {
        const swapperData = await connection.getAccountInfo(swapperStateAccount);
        if (!swapperData) {
            throw new Error("Invalid swapper state account");
        }
        if (swapperData.data[0] !== 1) {
            throw new Error("Minter not initialized");
        }
        const result = borsh_1.deserialize(this.schema, SwapperHeader, swapperData.data);
        return result;
    }
}
exports.SwapperHeader = SwapperHeader;
SwapperHeader.schema = new Map([
    [
        SwapperHeader,
        {
            kind: "struct",
            fields: [
                ["initialized", "u8"],
                ["signer_nonce", "u8"],
                ["copeMint", [32]],
                ["govTokenMint", [32]],
                ["govTokenPerCope", "u64"],
                ["maxQuantityPerWallet", "u64"],
                ["adminAddress", [32]],
                ["cope_vault", [32]],
            ],
        },
    ],
]);
class Swapper {
    constructor(swapperStateAccount) {
        this.swapperStateAccount = swapperStateAccount;
    }
    async load(connection) {
        this.swapperHeader = await SwapperHeader.retrieve(connection, this.swapperStateAccount);
    }
}
exports.Swapper = Swapper;
//# sourceMappingURL=state.js.map